export const DEFAULT_OG_TITLE = 'Boeiie.com';
export const DEFAULT_OG_DESCRIPTION = 'Boeiie is a platform built for sports fans by sports fans. Like to talk shop? Come join in on the discussion.';
export const DEFAULT_OG_URL = 'https://boeiie.com/';
export const DEFAULT_OG_IMAGE_URL = 'https://boeiie.com/media/og_image/main_og_image_2.png';
